import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8080';

const authHeaders = (accessToken) => ({ Authorization: `Bearer ${accessToken}` });

// Message lisible d'une erreur du relais (le backend Connector renvoie { error })
export const connectorServicesError = (e) =>
    e.response?.data?.error || e.response?.data?.message || e.message || 'Erreur inattendue';

export async function listConnectorServices(accessToken) {
    const res = await axios.get(`${API_URL}/api/connector-services`, { headers: authHeaders(accessToken) });
    return res.data.connectors || [];
}

// Aperçu du manifest d'un service, sans l'enregistrer
export async function discoverConnectorService(accessToken, url) {
    const res = await axios.post(`${API_URL}/api/connector-services/discover`, { url }, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function createConnectorService(accessToken, url) {
    const res = await axios.post(`${API_URL}/api/connector-services`, { url }, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function updateConnectorService(accessToken, connectorId, changes) {
    const res = await axios.put(`${API_URL}/api/connector-services/${encodeURIComponent(connectorId)}`, changes, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function checkConnectorService(accessToken, connectorId) {
    const res = await axios.post(`${API_URL}/api/connector-services/${encodeURIComponent(connectorId)}/check`, {}, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function deleteConnectorService(accessToken, connectorId) {
    const res = await axios.delete(`${API_URL}/api/connector-services/${encodeURIComponent(connectorId)}`, { headers: authHeaders(accessToken) });
    return res.data;
}
